import React, { FC, useEffect, useState } from "react";
import { emailSettingFields } from "../clientAllFields";
import { Grid } from "@mui/material";
import FormField from "../../../../components/common/FormField";
import { useDispatch } from "react-redux";
import { getCheckUniqueEmailAction, setCheckUniqueEmailAction, setNewClientLocal } from "../../../../store/reducers/adminClientsSlice";
import { useSelector } from "react-redux";
interface ManageEmailSettingProps {
  selectClient: any; // Adjust type as per your requirement,
  emailSettingError: any;
  formData?: any;
  setFormData?: any;
  checkValidator?: any;
  companyProfileIsError?: any;
  action?: any;
}
const EmailSettingForm: FC<ManageEmailSettingProps> = ({
  selectClient,
  emailSettingError,
  formData,
  setFormData,
  checkValidator,
  companyProfileIsError,
  action
}) => {
  const dispatch = useDispatch();
  const { newClientLocal, isEmailError } = useSelector((state: any) => state?.adminClients);
  const [isEmailActionCalled, setIsEmailActionCalled] = useState(false);
  const [isLoad, setIsLoad] = useState(false)

  const onChangeAction = (event: any) => {
    console.log('event log -change-',event, event.target.value + event.key)
    if(!isLoad)  return event.preventDefault();
    
    const { id, value } = event.target;
    dispatch(
      setNewClientLocal({
        ...newClientLocal,
        emailSetting: {
          ...newClientLocal?.emailSetting,
          [id]: value,
        },
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [id]: value }));
    dispatch(setCheckUniqueEmailAction(false));
  };

  const onBlurAction = (e: any) => {
    const { id, value } = e.target;
    checkValidator(e.target.id);
    if(id==="email" && value.trim() !== ''){
      setIsEmailActionCalled(true);
      
    }
  };

  useEffect(() => {
    if (isEmailActionCalled) {
      if (emailSettingError && !emailSettingError['email'] && isEmailActionCalled) {
        dispatch(getCheckUniqueEmailAction(newClientLocal?.emailSetting?.email));
        setIsEmailActionCalled(false);
      } else {
        setIsEmailActionCalled(false);
      }
    }
  }, [isEmailActionCalled]);
 
  return (
    <>
      {emailSettingFields?.map((field, i) => {
        return (
          !selectClient && (
            <Grid container spacing={2} key={i}>
              <FormField
                onPaste={(e:any)=>e.preventDefault()}
                onKeyDown={(event:any) => {
                  console.log('event log-',event, event.target.value + event.keyCode)
                  if(
                    event.keyCode === "Unidentified" || event.keyCode === undefined || event.keyCode === "undefined"
                    ){
                    event.preventDefault();
                    } else {
                      !isLoad && setIsLoad(true);
                    }
                  }}
                {...{
                  ...field,
                  value: newClientLocal?.emailSetting ? newClientLocal?.emailSetting[field?.id] : '',
                  ...{
                    variant: "outlined", // Adding this variant prop
                    onChange: onChangeAction,
                    onBlur: onBlurAction,
                    InputProps: {
                      ...field?.autocomplete && {autocomplete: field?.autocomplete},
                      ...action === "edit" && {disabled: field?.editReadOnly},
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px" }
                          : { padding: "10px 4px", height: "36px" },
                          
                    },
                    error: (field?.id === 'email' && isEmailError) ? true :
                      emailSettingError && emailSettingError[field?.id],
                    // helperText:
                    //   emailSettingError && emailSettingError[field?.id],
                  },
                }}
              />
            </Grid>
          )
        );
      })}
    </>
  );
};
export default EmailSettingForm;
